import React from 'react';
import DownloadManual from './DownloadManual';
class UnauthenticatedHeader extends React.Component {
  
    render() {
        return (
            <div style={{ display: "flow-root" }}>
                {!this.props.isUsaVersion && <DownloadManual />}
            </div>
        )
    }
}
export default UnauthenticatedHeader;